export const version = '2.15.2';
//# sourceMappingURL=version.js.map